import React, { useState } from 'react';
import { Helmet } from 'react-helmet'; // ▼▼▼ ADDED ▼▼▼
import { useLocation } from 'react-router-dom'; // ▼▼▼ ADDED ▼▼▼
import './Garden.css'; // Shared CSS

const MachiyaEn = () => {
    const [lightboxImage, setLightboxImage] = useState(null);
    const { pathname } = useLocation(); // ▼▼▼ ADDED ▼▼▼

    // Function to open the lightbox
    const openLightbox = (imageSrc) => {
        setLightboxImage(imageSrc);
    };

    return (
        // ▼▼▼ Wrapped with Fragment <> ▼▼▼
        <>
            {/* ▼▼▼ ADDED THIS ENTIRE HELMET BLOCK ▼▼▼ */}
            <Helmet>
                <title>Historic 150-Year Machiya | Five Features | Kanazawa Stay Akebono</title>
                <meta name="description" content="Stay in a genuine 150-year-old Kanazawa machiya. Discover the unique architectural beauty of a traditional Japanese townhouse, thoughtfully preserved at Akebono." />
                <link rel="canonical" href={`https://kanazawa-stay-akebono.com${pathname}`} />
                <meta property="og:title" content="Stay in a Historic 150-Year-Old Kanazawa Machiya | Akebono" />
                <meta property="og:description" content="Discover the unique architectural beauty of a traditional Japanese townhouse, thoughtfully preserved at Akebono." />
                <meta property="og:url" content={`https://kanazawa-stay-akebono.com${pathname}`} />
                <meta property="og:image" content="https://kanazawa-stay-akebono.com/images/feature-machiya.png" />
            </Helmet>
            {/* ▲▲▲ ADDITION ENDS HERE ▲▲▲ */}

            <div className="akebono-garden-page">

                {/* HERO Section */}
                <section className="akebono-garden-hero" style={{ backgroundImage: "url('/images/feature-machiya.png')" }}>
                    <div className="akebono-garden-hero-overlay">
                        <h1>150-Year Machiya</h1>
                    </div>
                </section>

                {/* Section 1: What is a Machiya? */}
                <section className="akebono-garden-culture">
                    <h2>What Makes a Machiya Special?</h2>
                    <p>
                        A "Machiya" is a traditional Japanese townhouse built during the Edo to early Showa periods, typically used as both a residence and a workplace for merchants and craftsmen. It features wooden lattice facades, indoor courtyards, and earthen floors that connect the front to the rear garden.
                    </p>
                    <p>
                        In Kanazawa, Machiya reflect the refined sensibilities of the Kaga domain and are renowned for their aesthetic harmony and functional beauty. Many still serve as homes and shops, forming part of the city’s living heritage.
                    </p>
                    <p>
                        Akebono is housed in a Kanazawa Machiya with over 150 years of history. The meticulous craftsmanship is evident in every detail, from the walls and fusuma screens to the beams and columns.
                    </p>
                    <p>
                        During your stay, enjoy not only the generous 170㎡ of living space, but also the exquisite architectural artistry of a truly historic residence.
                    </p>

                    <div className="akebono-garden-gallery">
                        <img src="/images/machiya1.jpg" alt="Machiya exterior" onClick={() => openLightbox('/images/machiya1.jpg')} />
                        <img src="/images/machiya2.jpg" alt="Lattice entrance" onClick={() => openLightbox('/images/machiya2.jpg')} />
                        <img src="/images/machiya3.jpg" alt="Courtyard view" onClick={() => openLightbox('/images/machiya3.jpg')} />
                        <img src="/images/room.jpg" alt="Traditional Japanese room" onClick={() => openLightbox('/images/room.jpg')} />
                    </div>
                </section>

                {/* Section 2: Architectural Highlights */}
                <section className="akebono-garden-feature">
                    <h2>Traditional Wisdom and Style</h2>
                    <p>
                        One signature of Machiya is the "tori-niwa" — a corridor-like earthen path that brings light and airflow deep into the home. Combined with shoji screens, latticework, and earthen walls, Machiya are naturally suited to Japan’s seasonal climate.
                    </p>
                    <p>
                        At Akebono, we preserved these timeless elements while integrating modern comforts such as floor heating, bath ventilation, and insulated windows. The result is a seamless fusion of history and comfort.
                    </p>
                    <h3>What is a Kanazawa Machiya?</h3>
                    <p>
                        "Kanazawa Machiya" refers to historic urban residences built before 1950, encompassing merchant homes, samurai residences, and early modern Japanese-style houses that evolved after the Meiji Restoration. Influenced by Western architectural trends, these homes retained traditional construction methods and materials.
                    </p>
                    <p>
                        Akebono falls under the category of "early modern Japanese style" within the Kanazawa Machiya classification. Its design blends historical elegance with livable functionality.
                    </p>
                    <h3>Shoin-zukuri: The Spirit of Hospitality</h3>
                    <p>
                        "Shoin-zukuri" is a traditional architectural style rooted in samurai culture that emerged in the Muromachi period. It was designed around the shoin — a study and reception room — and reflects the values of etiquette and refined hospitality.
                    </p>
                    <p>
                        Common features include tatami-matted floors, tokonoma alcoves for seasonal decorations, and formal seating areas. These spaces were designed to receive and honor guests, showcasing both sophistication and warmth.
                    </p>
                    <p>
                        Akebono incorporates this legacy of omotenashi, offering a space where architecture becomes part of the experience of welcoming and relaxation.
                    </p>
                </section>

                {/* Lightbox */}
                {lightboxImage && (
                    <div className="lightbox" onClick={() => setLightboxImage(null)}>
                        <span className="lightbox-close">&times;</span>
                        <img src={lightboxImage} alt="Enlarged view" className="lightbox-content" />
                    </div>
                )}
            </div>
        </> // ▲▲▲ Wrapped with Fragment <> ▲▲▲
    );
};

export default MachiyaEn;